import React from 'react';
import {connect} from 'react-redux';
import {dispatch} from 'redux';
import {Button, Icon} from "semantic-ui-react";
import {startCreateChallengeAction} from "./actions";

const mapStateToProps = (state) => {
    return {
        children: <span><Icon name="plus" />Create new break</span>,
        className: 'create-break-btn'
    }
};

const mapDispatchToProps = (dispatch) => ({
    onClick: () => dispatch(startCreateChallengeAction())
});

const CreateBreakButton = connect(mapStateToProps, mapDispatchToProps)(Button);

export default CreateBreakButton;



// WEBPACK FOOTER //
// ./public/pages/BreakCreator/CreateBreakButton.jsx